import { render, staticRenderFns } from "./Price.vue?vue&type=template&id=0e501371&scoped=true"
import script from "./Price.vue?vue&type=script&lang=js"
export * from "./Price.vue?vue&type=script&lang=js"
import style0 from "./Price.vue?vue&type=style&index=0&id=0e501371&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e501371",
  null
  
)

export default component.exports